"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirection = void 0;
var SortDirection;
(function (SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["desc"] = "desc";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
//# sourceMappingURL=sort.js.map